import { useEffect, type PropsWithChildren } from "react";
import "./FormContainer.css";

type FormContainerProps = PropsWithChildren<{
  className?: string;
  hasFooter?: boolean;
}>;

export default function FormContainer({
  children,
  className,
  hasFooter = false,
}: FormContainerProps) {
  useEffect(() => {
    const mainElement = document.querySelector("main");
    if (hasFooter && mainElement) {
      mainElement.classList.add("main--with-footer");
    }
    return () => {
      mainElement?.classList.remove("main--with-footer");
    };
  }, [hasFooter]);

  return <div className={`form_container ${className ?? ""}`}>{children}</div>;
}
